const rowStyle = (record) => {
    if(!record) return {}
    if (record.enabled === true) return { backgroundColor: '#dfd' };
    if (record.enabled === false) return { backgroundColor: '#fdd' };
    return {};
};

export default rowStyle;
